import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SimpleConfirmationComponent } from '@app/modules/shared/components/simple-confirmation/simple-confirmation.component';
import { LoggingService } from '@app/services/logging.service';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
@Injectable({
  providedIn: 'root'
})
export class PwaPromptInstallService {
  static readonly COMPONENT_NAME = 'PwaPromptInstallService';

  isHandset = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  private deferredPWAInstallPromptObs$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private loggingService: LoggingService,
    private translocoService: TranslocoService
  ) { 
    this.isHandset$.subscribe(r => {
      this.isHandset = r;
    });
  }


  getDeferredPWAInstallPromptObs(): Observable<any> {
    return this.deferredPWAInstallPromptObs$.asObservable();
  }

  setDeferredPWAInstallPromptObs(event: any) {
    this.deferredPWAInstallPromptObs$.next(event);
  }

  openInstallPWAPrompt() {
    if (!this.deferredPWAInstallPromptObs$.value || !this.isHandset) {
      return;
    }

    this.translocoService.selectTranslate('lang', {}, 'admin').subscribe((translation: string) => {
      let t = this.translocoService.translateObject('pwaInstallPromptComponent', {}, 'admin');
      let confirmBoxData: any = {
        title: t.title,
        message: t.message,
        iconClass: "tis-text-primary",
        icon: "install_mobile",
        approveButtonText: 'Install',
        approveButtonClass: "tis-btn-primary",
        cancelButtonText: 'Cancel',
        cancelButtonClass: "tis-btn-danger"
      };

      const dialogRef = this.dialog.open(SimpleConfirmationComponent, {
        width: "450px",
        panelClass: ['tis-simple-confirmation'],
        data: confirmBoxData,
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log("The dialog was closed with result:", result);
        if (result) {
          if (this.deferredPWAInstallPromptObs$.value) {
            this.deferredPWAInstallPromptObs$.value.prompt();
            this.deferredPWAInstallPromptObs$.value.userChoice.then((choiceResult: any) => {
              if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
              } else {
                console.log('User dismissed the install prompt');
              }
            });
          }
        }
      });
    });
  }
  
}
